import types from '../constants';
import Mola from '../api/mola';
import _get from 'lodash/get'

export const getMolaHub = playlistId => (dispatch, getState) => {
  const store = getState(),
    platformId = _get(store, 'runtime.platformId', 7)
  dispatch({
    type: types.GET_MOLA_HUB_LOADING,
    payload: {
      meta: {
        status: 'loading',
        error: '',
      },
      data: {},
    },
  })
  return Mola.getMolaHub({ playlistId, platformId }).then(result => {
    if (result.meta.status === 'error') {
      dispatch({
        type: types.GET_MOLA_HUB_ERROR,
        payload: result,
      })
    } else {
      dispatch({
        type: types.GET_MOLA_HUB_SUCCESS,
        payload: result,
      })
    }
  })
}